import { get, post } from '@/service/request';
const url = 'api';

export function postEncrypt(password) {
    return post(`${url}/auth/encrypt`, { plainText: window.btoa(password) });
}
// 測試登入 API
export function postLogin(data) {
    return post(`${url}/login`, data);
}
// 手機e方便、SCV SSO API
export function postSSOLogin(data) {
    return post(`${url}/auth/ssoLogin`, data);
}
// 登出 API
export function getLogout() {
    return get(`${url}/logout`);
}

export function postReserveVideoLinkLogin(data) {
    return post(`${url}/auth/reserveVideoLinkLogin`, data);
}
